module.exports = __webpack_public_path__ + "img/framework.7b1ef718.png";